<div class="card mb-0">
  <div class="card-body">
    <ng-container *ngIf="!isLoading; else isLoadingDT">
      <img
        src="../../../assets/img/xi.svg"
        height="34"
        class="cursor-pointer"
        alt=""
        style="width: fit-content"
      />
      <h3 class="text-center">Congratulations!</h3>
      <h4 class="text-center font-medium-5 mb-2">
        You have moved up in the leaderboard
      </h4>
      <div class="d-flex justify-content-center align-items-center flex-column">
        <img
          src="../../../../../assets/img/Group 5532.png"
          alt=""
          height="200"
        />
        <table class="table mt-2 w-md-80">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">NAME</th>
              <th scope="col">TYPE</th>
              <th scope="col">LEVEL</th>
              <th scope="col">WEEKLY POINTS</th>
              <th scope="col">TOTAL POINTS</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let member of leagueMembers; let i = index"
              [ngClass]="{
                'user-position': member?.userId == 4461418
              }"
            >
              <th scope="row">{{ i + 1 }}</th>
              <td>
                <img
                  src="../../../../../assets/img/Group 1000001774.png"
                  height="35"
                  width="35"
                  alt="avator"
                />
                {{ member.firstName }}
              </td>
              <td>{{ member.type }}</td>
              <td>{{ member.leagueLevelTitle }}</td>
              <td>{{ member.weekPoints }}</td>
              <td>{{ member.totalPoints }}</td>
            </tr>
          </tbody>
        </table>
        <div *ngIf="leagueMembers && leagueMembers?.length === 0">
          <ngb-alert [dismissible]="false" class="mb-0" [type]="'primary'">
            <div class="alert-body text-center">
              <span
                [data-feather]="'alert-circle'"
                [class]="'mr-25 align-middle'"
                [size]="35"
              ></span>
              <span> No leaderboard members</span>
            </div>
          </ngb-alert>
        </div>
        <button
          class="btn btn-primary btn-block border-3 font-medium-1 font-weight-bolder mt-3 w-50"
        >
          Continue
        </button>
      </div>
    </ng-container>
    <ng-template #isLoadingDT>

<div class="d-flex align-items-center justify-content-center h-100">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>

    </ng-template>
  </div>
</div>
